module.exports = __webpack_public_path__ + "img/dance-smile.a5e30ade.svg";